import { render, staticRenderFns } from "./Area.vue?vue&type=template&id=0c7e3231"
import script from "./Area.vue?vue&type=script&lang=js"
export * from "./Area.vue?vue&type=script&lang=js"
import style0 from "./Area.vue?vue&type=style&index=0&id=0c7e3231&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports